<script>
    import { metaInfo } from "@/core/MetaInfo";
    import TheDetailWrapper from "@auto-admin/components/TheDetailWrapper";
    import Versions from "@auto-admin/pages/Versions";
    import { apiUrl } from "@/utils";

    export default {
        name: "ModelDetail",
        props: {
            statusPage: String,
        },
        components: { Versions, TheDetailWrapper },
        data() {
            return {
                form: {
                    description: "",
                    name: "",
                    //photoId: "",
                    vendorId: null,
                    status: "actual",
                },
                file: null,
                vendorList: [],
                isLoading: false,
            };
        },
        computed: {
            isNew() {
                return this.statusPage === "new";
            },
            isView() {
                return this.statusPage === "view";
            },
            isEdit() {
                return this.statusPage === "edit";
            },
            title() {
                let filtered = {
                    new: "Добавить модель",
                    view: "Модель",
                    edit: "Редактировать модель",
                };
                return filtered[this.statusPage];
            },
        },
        mounted() {
            if (this.isEdit || this.isView) {
                this.loadDataForEdited();
            }
            this.getVendors();
        },
        methods: {
            apiUrl,
            send() {
                if (this.isNew) {
                    this.handlerForCreate();
                }
                if (this.isEdit) {
                    this.handlerForEdit();
                }
                if (this.isView) {
                    this.handlerForView();
                }
            },
            handlerForView() {
                this.$router.push({
                    name: "ModelEdit",
                    params: {
                        slug: this.$route.params.slug,
                    },
                });
            },
            handlerForEdit() {
                let data = {
                    description: this.form.description,
                    name: this.form.name,
                    //photoId: this.form.photoId,
                };
                this.$store.autoAdminApi.editModel(this.$route.params.slug, data).then(() => {
                    this.$router.push({
                        name: "Models",
                    });
                });
            },
            handlerForCreate() {
                this.$store.autoAdminApi.createModel(this.form).then(({ data }) => {
                    this.$router.push({
                        name: "ModelView",
                        params: {
                            slug: data.id,
                        },
                    });
                });
            },
            loadDataForEdited() {
                this.$store.autoAdminApi.getModel(this.$route.params.slug).then(({ data }) => {
                    delete data.id;
                    this.form = data;
                });
            },
            // deleteDropFile(index) {
            //     this.dropFiles.splice(index, 1);
            // },
            getVendors() {
                this.$store.autoAdminApi.getVendors().then(({ data }) => {
                    this.vendorList = data.items;
                });
            },
            uploadPhoto() {
                this.isLoading = true;
                let formData = new FormData();
                formData.append("photo", this.file);
                const fileReader = new FileReader();
                let arr = [];
                fileReader.onload = () => {
                    arr.push(fileReader.result);
                    this.$store.autoAdminApi
                        .uploadImages({ file: arr })
                        .then(({ data }) => {
                            this.form.photoId = data.id[0];
                            this.isLoading = false;
                        })
                        .catch(() => {
                            this.isLoading = false;
                        });
                };
                fileReader.readAsDataURL(this.file);
            },
        },
        metaInfo() {
            return metaInfo.getMeta("home");
        },
    };
</script>

<template>
    <div class="model-detail">
        <the-detail-wrapper
            :title="title"
            type-list="/models"
            :current-status="statusPage"
            @handler-submit="send"
        >
            <b-loading
                :is-full-page="true"
                v-model="isLoading"
                :can-cancel="false"
            ></b-loading>

            <b-field label="Название">
                <b-input v-model="form.name"></b-input>
            </b-field>

            <b-field label="Производитель">
                <b-select placeholder="Выбрать производителя" v-model="form.vendorId">
                    <option :value="vendor.id" v-for="vendor in vendorList" :key="vendor.id">
                        {{ vendor.name }}
                    </option>
                </b-select>
            </b-field>

            <b-field label="Описание">
                <b-input v-model="form.description" type="textarea"></b-input>
            </b-field>

            <b-field label="Изображение" message="Фото пока выводится статикой, не заполнять">
                <b-field class="file" :class="{ 'has-name': !!file }">
                    <b-upload v-model="file" class="file-label" @input="uploadPhoto">
                        <span class="file-cta">
                            <b-icon class="file-icon" icon="upload"></b-icon>
                            <span class="file-label">Загрузить фото</span>
                        </span>
                        <span class="file-name" v-if="file">
                            {{ file.name }}
                        </span>
                    </b-upload>
                </b-field>
            </b-field>
            <div class="block">
                <img
                    class="preview-img-single"
                    v-if="form.photoId"
                    :src="apiUrl('/gallery/image/' + form.photoId + '.orig')"
                    alt=""
                />
            </div>
        </the-detail-wrapper>

        <versions v-if="isEdit || isView" :vendor-id="form.vendorId"></versions>
    </div>
</template>

<style lang="scss"></style>
